import { render, staticRenderFns } from "./get-prize-method.vue?vue&type=template&id=10166cd5&scoped=true&"
import script from "./get-prize-method.vue?vue&type=script&lang=js&"
export * from "./get-prize-method.vue?vue&type=script&lang=js&"
import style0 from "./get-prize-method.scss?vue&type=style&index=0&id=10166cd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10166cd5",
  null
  
)

export default component.exports